import { ToggleSwitchDesignTokens } from '@primeuix/themes/types/toggleswitch';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { tFlat, t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/toggleswitch/index.ts
const ts = componentCommon.toggleswitch;
const tsCs = componentColorScheme.toggleswitch;

export const ToggleswitchTelekomDT: ToggleSwitchDesignTokens = {
  root: tFlat(ts),
  colorScheme: {
    light: {
      root: {
        background: t(tsCs.background),
        hoverBackground: t(tsCs.hover.background),
      },
      handle: tFlat(tsCs.handle),
    },
  },
};
